import axios from 'axios';
import { login } from '@services/auth/Auth';
import { mergeDeep } from '@utils/mergeDeep';

const publicApi = (): any => {
  const apiCall = axios.create({
    baseURL: process.env.API,
  });

  apiCall.interceptors.request.use(config => {
    let updatedConfig = {
      headers: {
        common: {},
        Accept: 'application/json',
        ContentType: 'application/json',
      },
    };
    if (config) {
      updatedConfig = mergeDeep(config, updatedConfig);
    }
    return updatedConfig;
  });

  apiCall.interceptors.response.use(
    (response: any) => response.data,
    async (error: any) => {
      const { response } = error;
      if (response && response.status === 401) {
        login();
      }
      return Promise.reject(response);
    },
  );

  return apiCall;
};

export { default as to } from '@utils/awaitTo';
export { default as handleApiError } from '@utils/errorHelper';

export default publicApi;
